// Zentrale, geteilte Erklaer-Quelle fuer Rundgang UND Seiten-Hilfe (kein scharfes S).
// Schluessel = Bereichs-Key (wie Navigation). Werte via t() uebersetzt (siehe i18n/onboarding.js).
// "todo" = kurze, konkrete Aktionen ("Das tun Sie hier"), damit der Kunde nie ueberlegen muss.
export const SECTION_GUIDE = {
  overview: [
    "Auf eine Kachel tippen, um direkt in den Bereich zu springen.",
    "Zuerst roten oder gelben Status anschauen.",
    "Offene Aufgaben und neue Anfragen erledigen.",
  ],
  website: [
    "Auf «Live prüfen» tippen, um den aktuellen Status zu sehen.",
    "Bei Rot kurz bei KEWAG melden.",
    "SSL, Backup und Ladezeit auf einen Blick prüfen.",
  ],
  leads: [
    "Eine Anfrage öffnen, um Nachricht und Kontaktdaten zu sehen.",
    "Direkt per Telefon oder E-Mail antworten.",
    "Bearbeitete Anfragen als erledigt markieren.",
  ],
  tasks: [
    "Vorschlag von KEWAG durchlesen.",
    "Auf «Freigeben» tippen, wenn alles passt.",
    "Bei Fragen kurz zurückschreiben.",
  ],
  support: [
    "Anliegen kurz beschreiben und absenden.",
    "Bei Bedarf ein Bild oder eine Datei anhängen.",
    "«Mit Mensch sprechen» wählen, wenn Sie eine Person möchten.",
  ],
  performance: [
    "Das monatliche Highlight ganz oben lesen.",
    "Sehen, woher Ihre Besucher kommen.",
    "Beliebteste Seiten für neue Inhalte nutzen.",
  ],
  documents: [
    "Foto, Screenshot, Datei oder Wunsch mit einem Tippen an KEWAG senden.",
    "Im Status-Fluss sehen Sie, wo Ihr Eingang gerade steht.",
    "Unter «Alle Dateien» finden Sie alles Gesendete und Bereitgestellte.",
  ],
  invoices: [
    "Rechnung mit einem Tippen als PDF herunterladen.",
    "Nach offenen oder bezahlten Rechnungen filtern.",
    "Paket und Vertragslaufzeit prüfen.",
  ],
  "next-steps": [
    "Empfehlung von KEWAG lesen.",
    "Auf «Angebot anfordern» tippen — unverbindlich.",
    "Offene Schritte nach und nach abhaken.",
  ],
  reports: [
    "Oben den gewünschten Monat auswählen.",
    "Besucher, Anfragen und Empfehlung anschauen.",
    "Mit «Als PDF exportieren» den Report sichern.",
  ],
  team: [
    "Auf «Benutzer einladen» tippen.",
    "Festlegen, welche Bereiche die Person sehen darf.",
    "Zugänge jederzeit anpassen oder entfernen.",
  ],
  security: [
    "Passwort bei Bedarf ändern.",
    "Zwei-Faktor-Authentifizierung (2FA) aktivieren.",
    "Angemeldete Geräte kontrollieren.",
  ],
  notifications: [
    "Auf die Glocke oben rechts tippen.",
    "Neue Aufgaben, Antworten und Rechnungen sehen.",
    "Direkt in die passende Ansicht springen.",
  ],
  contact: [
    "Auf «Nachricht senden» tippen.",
    "Anliegen beschreiben — wir melden uns.",
  ],
};

// Rundgang-Step-Key -> Guide-Key (Monatsreport heisst in der Navigation "report").
export const guideKeyFor = (key) => (key === "report" ? "reports" : key);
